module.exports = __webpack_public_path__ + "static/media/hangman10.48e16e87.svg";